import WeGiveRoot from './WeGiveRoot.jsx'

window.WeGiveApp = WeGiveRoot
